var _excluded = ["agent", "breadcrumbs", "listingsPerPageMobile", "listingsPerPageDesktop"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import AllhomesAgentProfilePage from './allhomes-agent-profile-page';
import AllhomesAgentModel from './components/agent-model';
import allhomesAgentProfileWrapper from './wrappers';
import * as styles from './allhomes-agent-profile.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentProfile = props => {
  var agent = props.agent,
    breadcrumbs = props.breadcrumbs,
    listingsPerPageMobile = props.listingsPerPageMobile,
    listingsPerPageDesktop = props.listingsPerPageDesktop,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (!agent) {
    return ___EmotionJSX("div", {
      css: styles.notFound
    }, props.notFoundText);
  }
  var mobile = props.media.mobile;
  var listingsPerPage = mobile ? listingsPerPageMobile : listingsPerPageDesktop;
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX(AllhomesBreadcrumbs, {
    className: "allhomes-breadcrumbs",
    items: breadcrumbs
  }), ___EmotionJSX(AllhomesAgentProfilePage, _extends({
    details: agent,
    listingsPerPage: listingsPerPage
  }, otherProps)));
};
AllhomesAgentProfile.propTypes = {
  notFoundText: PropTypes.string,
  agent: PropTypes.shape(AllhomesAgentModel).isRequired,
  listingsEndpointUrl: PropTypes.string.isRequired,
  onShowAll: PropTypes.func,
  onShowLess: PropTypes.func,
  googleMapsParams: PropTypes.shape({
    key: PropTypes.string.isRequired
  }).isRequired,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape(AllhomesBreadcrumbs.propTypes.items)).isRequired,
  maxPreviewHeight: PropTypes.number,
  listingsPerPageDesktop: PropTypes.number,
  listingsPerPageMobile: PropTypes.number,
  initialListings: AllhomesAgentProfilePage.propTypes.initialListings,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  }),
  enquiryEndpoint: PropTypes.string.isRequired,
  geocoderEndpoint: PropTypes.string.isRequired
};
AllhomesAgentProfile.defaultProps = {
  notFoundText: 'Could not find the agency',
  listingsPerPageDesktop: 6,
  listingsPerPageMobile: 2,
  maxPreviewHeight: undefined,
  initialListings: undefined,
  media: {},
  onShowAll: () => {},
  onShowLess: () => {}
};
export default allhomesAgentProfileWrapper(AllhomesAgentProfile);
export { AllhomesAgentProfile as BaseAllhomesAgentProfile };